
import { GENDER_ALL, GENDER_FEMALE, GENDER_MALE, GENDER_MIXED, GENDER_TEAMS_MAP, FORMAT_MAP, MAP_IMAGES_DIR } from "./data/Constants";
import React from 'react'

/*
    Retrieves our gender and age information from the provided clubDetails map.
    returns a map with the following keys:
    minAge, maxAge, genders
*/
export function collateGenderAndAgeDetails(clubDetails){
    let minAge = null;
    let maxAge = null;
    let hasMale = false, hasFemale = false;
    if (clubDetails.demographics){
        clubDetails.demographics.forEach((demo) => {
            if (minAge === null || minAge > demo.ageFrom){
                minAge = demo.ageFrom;
            }
            if (maxAge === null || maxAge < demo.ageTo){
                maxAge = demo.ageTo;
            }
            const gender = demo.gender
            if (gender === GENDER_ALL || gender === GENDER_MIXED){
                hasMale = true;
                hasFemale = true;
            }
            else if(gender === GENDER_FEMALE){
                hasFemale = true;
            } 
            else if (gender === GENDER_MALE){
                hasMale = true;
            } 
        })
    }
    
    let genders  = '';
    if (hasFemale && hasMale){
        genders = "M/F";
    } else if (hasMale){
        genders = "M"
    } else if (hasFemale){
        genders = "F"
    }

    return {
        'minAge': minAge,
        'maxAge': maxAge,
        'genders': genders
    }
}

/** Render out our logo images */
export function renderLogoImages(formats){
    // console.log(formats);
   let arrayImage = formats.map(item => item.format).filter((value, index, self)=>self.indexOf(value) === index)
    return arrayImage.map((format, index) => {
      if (format in FORMAT_MAP){
        let formatMap = FORMAT_MAP[format];
        let imgSrc =  MAP_IMAGES_DIR + 'logos/' + formatMap.logo;
        let imgSrc2x = MAP_IMAGES_DIR + 'logos/' + formatMap.logo_2x;
        let imgAlt = formatMap.imgTitle;
        return (<img src={imgSrc} alt={imgAlt} key={index} srcSet={imgSrc2x + ' 2x'} className="club-format-logo"/>)
      }
    })
  }

export function renderDemographics(demographics){
    
    return demographics.map((demo, index) => {
        let teamsText = demo.gender;
        if (demo.gender in GENDER_TEAMS_MAP){
            teamsText = GENDER_TEAMS_MAP[demo.gender];
        }
        
        return (
            <span className="capitalize" key={index}>
                {index > 0 && <span className="large-bull">&bull;</span>} {teamsText} {(demo.ageFrom || demo.ageTo) && <span>{demo.ageFrom}-{demo.ageTo}yrs</span>}
            </span>
        )
    })
}